import get from 'lodash.get';

const getWhiteLabelStatus = (rootState) => get(rootState, 'user.partnerData.isWhiteLabel', false);

export default getWhiteLabelStatus;
